export const getDialogueError = ({ dialogue }) => dialogue.error;
export const getDialogueMessage = ({ dialogue }) => dialogue.message;
export const getLoadingDialogue = ({ dialogue }) => dialogue.loading;
export const getDialogueStore = ({ dialogue }) => dialogue.dialogueStore;
export const getDialoguesArrayStore = ({ dialogue }) => dialogue.dialoguesArray;
export const getDialoguesArrayStoreNew = ({ dialogue }) =>
  dialogue.dialoguesArrayNew;
export const getIsNewMessage = ({ dialogue }) => dialogue.isNewMessage;
export const getStatusDialogueList = ({ dialogue }) =>
  dialogue.statusDialogueList;
